export default __webpack_public_path__ + "static/media/IconVenue.977f8370.svg";